import { Directive, HostBinding } from "@angular/core";

@Directive({ selector: ".md-form" })
export class MdFormDirective {
  @HostBinding("class.active") active: boolean;
}
